import React, { useContext, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from './components/Login/AuthContext';
import { useTranslation } from 'react-i18next';
import App from './App';
import LandingPage from './components/Page/LandingPage';
import LinkedinHeadshotPage from './components/Page/LinkedinHeadshotPage';
import TermsOfService from './components/Page/TermsOfService';
import PrivacyPolicy from './components/Page/PrivacyPolicy';
import PricingPage from './components/Page/PricingPage';
import Login from './components/Login/Login';
import Signup from './components/Login/Signup';
import LoginWithToken from './components/Login/LoginWithToken';
import ScrollToTop from './components/UI/ScrollToTop';
import PhotoManager from './components/App/PhotoManager';
import StylesManager from './components/StyleAdmin/StylesManager';

// Import styles if needed
import './App.css';

// Composant pour définir la langue
const LanguageSetter = ({ language, children }) => {
    const { i18n } = useTranslation();
    
    useEffect(() => {
        i18n.changeLanguage(language);
    }, [language, i18n]);
    
    return children;
};

const AppRouter = () => {
    const { isAuthenticated } = useContext(AuthContext);

    return (
        <Router>
            <ScrollToTop />
            <Routes>
                {/* Routes françaises pour les pages publiques concernées */}
                <Route path="/fr">
                    <Route path="" element={
                        <LanguageSetter language="fr">
                            {!isAuthenticated ? <LandingPage /> : <Navigate to="/app" />}
                        </LanguageSetter>
                    } />
                    <Route path="linkedin-headshot" element={
                        <LanguageSetter language="fr">
                            <LinkedinHeadshotPage />
                        </LanguageSetter>
                    } />
                    <Route path="pricing" element={
                        <LanguageSetter language="fr">
                            <PricingPage />
                        </LanguageSetter>
                    } />
                    <Route path="terms-of-service" element={
                        <LanguageSetter language="fr">
                            <TermsOfService />
                        </LanguageSetter>
                    } />
                    <Route path="privacy-policy" element={
                        <LanguageSetter language="fr">
                            <PrivacyPolicy />
                        </LanguageSetter>
                    } />
                    {/* Les routes d'authentification françaises redirigent vers les mêmes pages que les routes anglaises */}
                    <Route path="login" element={isAuthenticated ? <Navigate to="/app" /> : 
                        <LanguageSetter language="fr">
                            <Login />
                        </LanguageSetter>
                    } />
                    <Route path="signup" element={isAuthenticated ? <Navigate to="/app" /> : 
                        <LanguageSetter language="fr">
                            <Signup />
                        </LanguageSetter>
                    } />
                </Route>

                {/* Routes originales en anglais */}
                {/* Public routes */}
                <Route path="/" element={!isAuthenticated ? <LandingPage /> : <Navigate to="/app" />} />
                <Route path="/linkedin-headshot" element={<LinkedinHeadshotPage />} />
                <Route path="/terms-of-service" element={<TermsOfService />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/pricing" element={<PricingPage />} />
                <Route path="/admin/styles" element={<StylesManager />} />
                
                {/* Auth routes with redirects */}
                <Route
                    path="/login"
                    element={isAuthenticated ? <Navigate to="/app" /> : <Login />}
                />
                <Route
                    path="/signup"
                    element={isAuthenticated ? <Navigate to="/app" /> : <Signup />}
                />
                <Route
                    path="/login_with_token"
                    element={isAuthenticated ? <Navigate to="/app" /> : <LoginWithToken />}
                />
                             
                {/* App routes - all nested within App component */}
                <Route
                    path="/app/*"
                    element={isAuthenticated ? <App /> : <Navigate to="/login" />}
                />
                
                {/* Fallback route */}
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </Router>
    );
};

export default AppRouter; 